import { CareChatMessage } from '@web/types/careChat'

export const CARE_CHAT_EVENT_TYPE = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  RECONNECTING: 'reconnecting',
  NEW_MESSAGE: 'newMessage',
  MESSAGE_SENT: 'messageSent',
  HISTORY: 'history',
  BADGE_UPDATED: 'badgeUpdated',
  MANAGER_TYPING: 'managerTyping',
  CONVERSATION_CLOSED: 'conversationClosed',
  REQUEST_FAILED: 'requestFailed',
  CONNECTION_GAVE_UP: 'connectionGaveUp',
  ERROR: 'error'
} as const

export type CareChatEventType = typeof CARE_CHAT_EVENT_TYPE[keyof typeof CARE_CHAT_EVENT_TYPE]

export interface CareChatConnectedEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.CONNECTED
  chatId?: string
  conversationIdList: string[]
  backendUrl?: string
}

export interface CareChatDisconnectedEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.DISCONNECTED
}

export interface CareChatReconnectingEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.RECONNECTING
  attemptCount: number
}

export interface CareChatNewMessageEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.NEW_MESSAGE
  message: CareChatMessage
  serverBadgeCount?: number
}

export interface CareChatMessageSentEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.MESSAGE_SENT
  localUid: string
  message: CareChatMessage
}

export interface CareChatHistoryEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.HISTORY
  messages: CareChatMessage[]
}

export interface CareChatBadgeUpdatedEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.BADGE_UPDATED
  badgeCount: number
}

export interface CareChatManagerTypingEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.MANAGER_TYPING
  conversationId?: string
  expiredAtTimestamp?: number
}

export interface CareChatConversationClosedEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.CONVERSATION_CLOSED
}

export interface CareChatRequestFailedEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.REQUEST_FAILED
  uid: string
  errorMessage: string
}

export interface CareChatConnectionGaveUpEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.CONNECTION_GAVE_UP
  totalAttemptCount: number
}

export interface CareChatErrorEvent {
  type: typeof CARE_CHAT_EVENT_TYPE.ERROR
  errorMessage: string
}

export type CareChatEvent =
  | CareChatConnectedEvent
  | CareChatDisconnectedEvent
  | CareChatReconnectingEvent
  | CareChatNewMessageEvent
  | CareChatMessageSentEvent
  | CareChatHistoryEvent
  | CareChatBadgeUpdatedEvent
  | CareChatManagerTypingEvent
  | CareChatConversationClosedEvent
  | CareChatRequestFailedEvent
  | CareChatConnectionGaveUpEvent
  | CareChatErrorEvent
